// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieNotice_wrapper__hOxsZ","actions":"CookieNotice_actions__MUkk3"};